import { render, staticRenderFns } from "./appNotification.vue?vue&type=template&id=4b2e9e16&scoped=true&"
import script from "./appNotification.vue?vue&type=script&lang=js&"
export * from "./appNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e9e16",
  null
  
)

export default component.exports